<template>
  <button :type="type" @click="handleClick" enterkeyhint="enter" :disabled="disabled" :class="{ 'opacity-60 pointer-events-none': disabled }">
    <slot></slot>
    <svg v-if="loading" class="animate-spin -mr-4 ml-4 h-[20px] w-[20px] fill-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
      <path
        class="group-hover:fill-blue opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      ></path>
    </svg>
  </button>
</template>

<script lang="ts">
  import { Component, Vue, Prop } from "vue-facing-decorator";

  @Component
  export default class FormSubmit extends Vue {
    @Prop({ default: false }) readonly loading!: boolean;

    @Prop({ default: false }) readonly success!: boolean;

    @Prop({ default: false }) readonly disabled!: boolean;

    @Prop({ default: "submit" }) readonly type!: "button" | "submit";

    handleClick() {
      if (this.type === "submit") {
        return;
      }

      this.$emit("click");
    }
  }
</script>
